import { Button } from '@heidi/design-system/button';
import { HeidiLoader } from '@heidi/design-system/heidi-loader';
import { TypographyP2 } from '@heidi/design-system/typography';
import { workCanvasSurfaceClassName } from '@heidi/utils';
import { useIntl } from 'react-intl';

interface ObjectWorkspaceRoutePendingProps {
  isError: boolean;
  onRetry: () => void;
}

/** Loading / error shell while the URL object is unresolved from recent visits. */
export function ObjectWorkspaceRoutePending({
  isError,
  onRetry,
}: ObjectWorkspaceRoutePendingProps): JSX.Element {
  const intl = useIntl();

  if (isError) {
    return (
      <div
        className={workCanvasSurfaceClassName(
          'flex size-full flex-col items-center justify-center gap-3'
        )}
        role="alert"
      >
        <TypographyP2 className="text-text-secondary">
          {intl.formatMessage({
            defaultMessage: 'Could not load this workspace',
            id: 'us9kznq7Ec',
            description:
              'Error when recent visits fail while opening a URL-selected Home object',
          })}
        </TypographyP2>
        <Button type="button" variant="secondary" size="sm" onClick={onRetry}>
          {intl.formatMessage({
            defaultMessage: 'Try again',
            id: 'YaPimi1PxP',
            description: 'Retry loading recent visits for the object workspace',
          })}
        </Button>
      </div>
    );
  }

  return (
    <div
      className={workCanvasSurfaceClassName('flex size-full items-center justify-center')}
      aria-busy="true"
      aria-label={intl.formatMessage({
        defaultMessage: 'Loading object workspace',
        id: 'df237ftsZV',
        description: 'Accessible status while restoring a URL-selected Home object',
      })}
    >
      <HeidiLoader />
    </div>
  );
}
